import { FaqProps } from "@ft/components/common/Faq";

const jsonValidatorFaqData: FaqProps[] = [
  {
    question: "What is JSON Validator?",
    ans: "JSON validator is an online tool that helps to check if a provided JSON code is valid and well-formed according to the JSON standard.",
  },
  {
    question: "How can i use this tool?",
    ans: "You can just paste or load it from a JSON file and see the magic.",
  },
  {
    question: "How does it perform JSON validation?",
    ans: "It verifies your JSON content according to JS standards and notifies you if notice any error—which can occur for a variety of reasons such as lack of attention.",
  },
];

export default jsonValidatorFaqData;
